<template>
  <v-row>
    <v-col cols="12">
      <h2 v-if="$mq == 'sm'">{{ titulo }}</h2>
      <h1 v-else>{{ titulo }}</h1>            
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    titulo: String,
  },
};
</script>
